import React from 'react';
import textSizeUtils from '../../../utils/TextSizeUtils';
import shapeTypes from '../../../../constants/ShapeConstants';
import { ColorPallete } from '../components/subcomponents/ColorPallete';
import { BorderStyleArea } from '../components/subcomponents/BorderStyleArea';
import appParameters from '../../../utils/AppParameters';
import configuration from '../../../../constants/Configuration';
import hoverManager from '../../../utils/HoverManager';
import mouseUtils from '../../../utils/MouseUtils';

const EditShapeButton = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        let value = (this.props.index === this.props.selectedButton) ? -1 : this.props.index;

        this.props.selectButton(value);

        this.setState({
            isOver: false
        });
    },
    getLefPosition() {
        let leftPosition = 0;
        let buttonSize = this.props.width;
        let gap = this.props.gap;

        switch (this.props.index) {
            case 0: {
                leftPosition = 0;
                break;
            }
            case 1: {
                leftPosition = buttonSize + gap;
                break;
            }
        }

        return leftPosition;
    },
    isSelected() {
        let  value = false;

        switch(this.props.index) {
            case 0: { // Fill color
                return (this.props.selectedButton === 0);
            }
            case 1: { // Stroke color
                return (this.props.selectedButton === 1);
            }
        }

        return value;
    },
    getLabel() {
        switch(this.props.index) {
            case 0: { // Fill color
                return hoverManager.getText('fillColor');
            }
            case 1: { // Stroke color
                return hoverManager.getText('borderColor');
            }
        }
    },
    getIcon() {
        let host;

        if (configuration.LOAD_LOCAL === true)
            host = '';
        else
            host = appParameters.RESOURCES_LOCATION();

        switch(this.props.index) {
            case 0: { // Fill color
                return host + 'assets/textEditor/fillColor';
            }
            case 1: { // Stroke color
                return host + 'assets/textEditor/strokeColor';
            }
        }
    },
    render() {
        const buttonWidth = this.props.width;
        const buttonHeight = this.props.height;
        let isSelected = this.isSelected();
        let backgroundColor = isSelected ? '#0078a3' : (this.state.isOver ? '#edefff' : '#f9f9f9');
        let textColor = isSelected ? '#ffffff' : '#000000';

        let buttonStyle = {
            position: 'absolute',
            top: 0,
            width: buttonWidth,
            height: buttonHeight,
            left: this.getLefPosition(),
            cursor: 'pointer',
            background: backgroundColor,
            borderRadius: 4,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#c4c4c4'
        };

        let iconStyle = {
            position: 'absolute',
            top: 1,
            left: 5,
            width: 23,
            height: 23,
            pointerEvents: 'none'
        };

        let spanElement;

        if (this.props.index === 2) {
            iconStyle.width = 30;
            iconStyle.height = 30;
            iconStyle.top = 2;
        } else {
            let colorHeight = 4;
            let colorStyle = {
                position: 'absolute',
                bottom: colorHeight - 2,
                left: 5,
                width: 23,
                height: colorHeight,
                background: this.props.currentColor,
                borderRadius: 50,
                borderStyle: 'solid',
                borderWidth: 1,
                borderColor: '#c4c4c4',
                pointerEvents: 'none'
            };

            spanElement = <span style={colorStyle}></span>;
        }

        let titleStyle = {
            position: 'absolute',
            top: 10,
            right: 0,
            width: buttonWidth - 30,
            fontSize: 11,
            color: textColor,
            textAlign: 'center',
            pointerEvents: 'none'
        };

        let icon = this.getIcon();

        if (isSelected)
            icon = icon + '_white.svg';
        else
            icon = icon + '.svg';

        return (
            <button id={this.props.id} aria-label={this.getLabel()} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <img alt='' aria-hidden='true' style={iconStyle} src={icon}/>
                {spanElement}
                <span style={titleStyle}>{this.getLabel()}</span>
            </button>
        );
    }
});

export const CollorButtonsArea = React.createClass({
    getInitialState() {
        return {
            selectedButton: -1,
            selectedMenu: 'none'
        };
    },
    showMenu(value) {
        this.setState({
            selectedMenu: value
        });
    },
    selectButton(value) {
        let val = (value === this.state.selectedButton) ? -1 : value;
        let menuValue = 'none';

        this.setState({
            selectedButton: val
        });

        switch (val) {
            case -1: {
                menuValue = 'none';
                break;
            }
            case 0: {
                menuValue = 'changeShapeFillColor';
                break;
            }
            case 1: {
                menuValue = 'changeShapeStrokeColor';
                break;
            }
        }

        this.showMenu(menuValue);
        this.props.forceUpdateTextEditor(menuValue);
    },
    getCurrentColor(type) {
        let color = '#000000';

        if (type === 'changeShapeFillColor')
            color = this.props.contextTarget.fill;
        else {
            if (type === 'changeShapeStrokeColor')
                color = this.props.contextTarget.stroke;
        }

        color = textSizeUtils.getCorrectColor(color);

        return color;
    },
    render() {
        let isSimpleBox = this.props.contextTarget.type === shapeTypes.TEXTBOXSIMPLE ? true : false;

        if (isSimpleBox)
            return (<div/>);

        let gap = 10;
        let elementWidth = Math.floor((this.props.width - gap) / 2);
        let elementHeight = this.props.gridSize;

        let menuStyle = {
            position: 'absolute',
            width: this.props.width,
            top: this.props.top
        };

        let buttonsHolderStyle = {
            position: 'absolute',
            top: this.props.topGap
        };

        let colorElementSize = this.props.width / 10;
        let menuElement;
        let idValue;

        if (this.state.selectedMenu === 'changeShapeFillColor') {
            menuElement = <ColorPallete type={this.state.selectedMenu} currentColor={this.getCurrentColor(this.state.selectedMenu)} executeCommand={this.props.executeCommand} top={this.props.topGap + elementHeight} topGap={this.props.topGap} width={this.props.width} gridSize={colorElementSize} contextTarget={this.props.contextTarget} forceUpdateTextEditor={this.props.forceUpdateTextEditor}/>;
        } else if (this.state.selectedMenu === 'changeShapeStrokeColor') {
            menuElement = <BorderStyleArea top={elementHeight + this.props.topGap} width={this.props.width} executeCommand={this.props.executeCommand} contextTarget={this.props.contextTarget} type={this.state.selectedMenu} currentColor={this.getCurrentColor(this.state.selectedMenu)} topGap={this.props.topGap} gridSize={colorElementSize} dispatch={this.props.dispatch} forceUpdateTextEditor={this.props.forceUpdateTextEditor}/>;
        } else {
            if (!this.props.contextTarget.isMindMap)
                idValue = 'lastFocusableObjectForTextEditorTool';
        }

        return (
            <div style={menuStyle}>
                <div style={buttonsHolderStyle}>
                    <EditShapeButton index={0} selectedButton={this.state.selectedButton} selectButton={this.selectButton} currentColor={this.getCurrentColor('changeShapeFillColor')} width={elementWidth} height={elementHeight} gap={gap}/>
                    <EditShapeButton index={1} selectedButton={this.state.selectedButton} selectButton={this.selectButton} currentColor={this.getCurrentColor('changeShapeStrokeColor')} width={elementWidth} height={elementHeight} gap={gap} id={idValue}/>
                </div>

                {menuElement}
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/CollorButtonsArea.js
 **/